<btn [disabled]="disabled" [text]='text' [bcg]='bcg' (click)='emit.emit()'
     [btnHeight]='btnHeight' [btnWidth]='btnWidth'
     [style]='{h:btnHeight,w:btnWidth}|getStyles'></btn>